<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent width="800px">
      <v-card>
        <!-- <v-card-title class="green darken-2 white--text">
          <span class="text-center headline"> Ver detalles de la promocion </span>
        </v-card-title> -->
        <v-card-text>
          <v-container>
            <h4 class="mb-0">{{ promo.nombre }}</h4>
            <v-divider class="my-0"></v-divider>
            <v-row>
              <v-col cols="12" sm="5">
                <p class="mb-0"><b class="blue--text"> Tipo de aplicacion: </b> {{ promo.ambiente.ambiente }}</p>
                <ul>
                  <li v-for="(d, i) in promo.ambiente.detalle" :key="i">{{ d.nombre }}</li>
                </ul>
              </v-col>

              <v-col cols="12" sm="7">
                <p class="mb-0"><b class="blue--text">Creado por:</b> {{ promo.creado_por }}</p>
                <p class="mb-0"><b class="blue--text">Aprobado por:</b> {{ promo.aprobado_por }}</p>
                <p class="mb-0"><b class="blue--text">Descripcion:</b> {{ promo.descripcion }}</p>
                <p class="mb-0"><b class="blue--text">Fecha de Inicio:</b> {{ promo.fecha_inicio }}</p>
                <p class="mb-0"><b class="blue--text">Fecha finalizacion:</b> {{ promo.fecha_fin }}</p>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="promo.detalle_promocion"
              :itemsPerPage="-1"
              class="elevation-0"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:[`item.valor_descuento`]="{ item }">
                <p class="mb-0">
                  {{ item.valor_descuento }} <span> {{ item.is_porcentaje ? '%' : 'Bs' }} </span>
                </p>
              </template>

              <template v-slot:[`item.is_porcentaje`]="{ item }">
                <p class="mb-0">{{ item.is_porcentaje ? 'Porcentual' : 'Monto' }}</p>
              </template>
            </v-data-table>
          </v-container>

          <p class="text-center red--text">{{ msg }}</p>
          <v-progress-linear indeterminate v-if="loading" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded outlined @click="dialog = !dialog"> <v-icon>mdi-close</v-icon> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
  .end-input >>> input {
    text-align: end;
  }
</style>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        promo: {
          id: null,
          nombre: '',
          descripcion: '-',
          fecha_inicio: '',
          fecha_fin: '',
          estado: false,
          creado_por: '',
          aprobado_por: null,
          ambiente: {},
          detalle_promocion: [],
        },

        tipos: [
          { id: 1, text: 'General' },
          { id: 2, text: 'Unidad de Negocio' },
          { id: 3, text: 'Sede' },
        ],
        headers: [
          //   { text: '#', value: 'nro', width: 30 },
          { text: 'Concepto', value: 'nombre_concepto' },
          { text: 'Tipo descuento', value: 'is_porcentaje', width: 150 },
          { text: 'Descuento', value: 'valor_descuento', width: 150 },
        ],
        conceptossels: [],
        items_unidades: [],
        item_unidad: null,
        items_sedes: [],
        item_sede: null,
      };
    },
    components: {},
    computed: {},
    methods: {
      openmodal(item) {
        this.msg = '';
        this.dialog = true;
        this.getpromo(item.id);
      },

      getpromo(id) {
        this.loading = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones/${id}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log(response, data);

            vue.promo.id = data.id;
            vue.promo.nombre = data.nombre;
            vue.promo.descripcion = data.descripcion;
            vue.promo.fecha_inicio = data.fecha_inicio;
            vue.promo.fecha_fin = data.fecha_fin;
            vue.promo.estado = data.estado;
            vue.promo.creado_por = data.creado_por;
            vue.promo.aprobado_por = data.aprobado_por;
            vue.promo.ambiente = JSON.parse(data.ambiente);
            vue.promo.detalle_promocion = data.detalle_promocion;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
    },
  };
</script>
